import React, { Component } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import {Settings} from './settings';
import {Log} from './log.js'

const log = new Log(Settings.logLevel);

class PTLearnometer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            w: 14,
            h: 275,
            max: 100,
            currValue: this.props.value
        }
        this.approachValue = this.approachValue.bind(this);
    }

    //shouldComponentUpdate(nextProps, nextState) {
        //return nextProps.value !== this.props.value || nextState.currValue !== this.state.currValue;
    //}

    // This function is invoked when the state is changing, which means
    // 'l' has changed in the story. 
    componentDidUpdate(nextProps, nextState) {
        //log.debug("[Learnometer] will update: " + JSON.stringify(this.props) + " -> " + JSON.stringify(nextProps) + "; state: " + JSON.stringify(this.state) + " -> " + JSON.stringify(nextState));

        if (nextProps.value !== this.props.value) {
            log.debug("[Learnometer] l changed.");
            this.valueWillChange(nextProps.value);
        }
        //else this.props.completionHandler();
    }

    // Detects the amount of change (within a tolerance) and compares this with
    // certain predefined values. Then hands off execution to the appropriate sound.
    valueWillChange(newValue) {
        log.debug("[Learnometer] valueWillChange: " + newValue);
        let epsilon = 0.8;
        let delta = this.props.value - newValue;
        log.debug("[Learnometer] delta is " + delta);
        if      (Math.abs(delta - this.props.full) < epsilon) this.fullAudio.audioEl.play();
        else if (Math.abs(delta - this.props.half) < epsilon) this.halfAudio.audioEl.play();
        else if (Math.abs(delta - this.props.loss) < epsilon) this.lossAudio.audioEl.play();
        else    this.neutralAudio.audioEl.play();
    }
    
    render() {
        const merc_bar_h = this.state.h * this.state.currValue / this.state.max;
        const merc_bar_y = this.state.h - merc_bar_h;
        return (
            <div className="pt-learnometer">
                <ReactAudioPlayer
                    src={Settings.fullAudio}
                    ref={(element) => {this.fullAudio = element}}
                    onEnded={this.approachValue}
                    onError={this.approachValue}
                />
                <ReactAudioPlayer
                    src={Settings.halfAudio}
                    ref={(element) => {this.halfAudio = element}}
                    onEnded={this.approachValue}
                    onError={this.approachValue}
                />
                <ReactAudioPlayer
                    src={Settings.neutralAudio}
                    ref={(element) => {this.neutralAudio = element}}
                    onEnded={this.approachValue}
                    onError={this.approachValue}
                />
                <ReactAudioPlayer
                    src={Settings.lossAudio}
                    ref={(element) => {this.lossAudio = element}}
                    onEnded={this.approachValue}
                    onError={this.approachValue}
                />
                <ReactAudioPlayer
                    src={Settings.tickAudio}
                    ref={(element) => {this.tickAudio = element}}
                    onEnded={this.approachValue}
                    onError={this.approachValue}
                />
                <svg width={this.state.w} height={this.state.h}>
                    <rect className="pt-learnometer-mercury" 
                        x={0}
                        y={merc_bar_y}
                        width={this.state.w}
                        height={merc_bar_h}
                        fill={"#00ffe6"}
                    />
                </svg>
            </div>
        )
    }
    
    // Whereas this.props.value specifies the target value of the learnometer, 
    // this.state.currValue specifies the (internal) current value. approachValue
    // is used as part of a loop to update currValue so that it approaches value. 
    approachValue() {
        let epsilon = 0.8;
        let delta = this.props.value - this.state.currValue;

        if (delta > epsilon) {
            const newValue = Math.min(this.state.currValue + 1, this.props.value);
            log.debug("[Learnometer] going up to "+newValue);
            this.setState({currValue: newValue}, (function(){ this.tickAudio.audioEl.play(); }).bind(this))
        }
        else if (delta < -epsilon) {
            const newValue = Math.max(this.state.currValue - 1, this.props.value);
            log.debug("[Learnometer] going down to "+newValue);
            this.setState({currValue: newValue}, (function(){ this.tickAudio.audioEl.play(); }).bind(this))
        }
        // Let the DialogueApp know all the audio playing has completed.
        else {
            log.debug("[Learnometer] target value reached.");
            this.props.completionHandler()
        }
    }
}

export {PTLearnometer};



// WEBPACK FOOTER //
// ./src/learnometer.js